import Logo from "@/assets/logo.svg?react";
import { useGoogleTagManager } from "@/features/auth/subscription/hooks/useGoogleTagManager.ts";
import { usePageTitle } from "@/hooks/usePageTitle";

export function CheckEmailScreen() {
  usePageTitle("Check your email");
  useGoogleTagManager("GTM-5X67HTS");

  return (
    <div className="min-h-screen bg-bg-secondary flex items-center justify-center p-6">
      <div className="text-center">
        <div className="mb-6 animate-pulse">
          <Logo className="w-12 h-12 mx-auto" />
        </div>
        <h2 className="text-2xl font-semibold text-text-primary mb-3">
          Success! Check your email.
        </h2>
        <p className="text-text-secondary text-base leading-relaxed mb-6">
          Go to your inbox for the next steps.
        </p>
        <div className="flex items-center justify-center gap-2">
          <div
            className="w-2 h-2 bg-purple-600 rounded-full animate-bounce"
            style={{ animationDelay: "0ms" }}
          />
          <div
            className="w-2 h-2 bg-purple-600 rounded-full animate-bounce"
            style={{ animationDelay: "150ms" }}
          />
          <div
            className="w-2 h-2 bg-purple-600 rounded-full animate-bounce"
            style={{ animationDelay: "300ms" }}
          />
        </div>
      </div>
    </div>
  );
}
